import React, { useContext, useEffect } from 'react';
import PersonDocs from 'containers/pages/persons/PersonDocs';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import RemoveFilesButton from 'containers/partials/buttons/RemoveFilesButton';
import messages from 'messages';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import usePersonDocStore from 'containers/pages/persons/store/PersonDocStore';
import useFiles from 'hooks/queries/useFiles';
import { StoreContext } from 'index';

const PersonDocsTab = () => {
  const {
    authStore: {
      user: { rootEntityId }
    }
  } = useContext(StoreContext);
  const { entityId, personId } = useParams();
  const intl = useIntl();
  const { setMenuItems, clearAllContext } = useContextMenu();
  const { getFiles } = useFiles({
    entityId: rootEntityId,
    linkId: personId
  });
  const selectedDocs = usePersonDocStore(s => s.selectedDocs);
  const clearSelectedDocs = usePersonDocStore(s => s.clearSelectedDocs);

  useEffect(() => {
    return () => {
      clearSelectedDocs();
    };
  }, []);

  useEffect(() => {
    const contextButtons = [];
    contextButtons.push(<RemoveFilesBtn />);

    setMenuItems(contextButtons);

    return () => {
      clearAllContext();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDocs]);

  const refetchFiles = async () => {
    try {
      await getFiles();
      clearSelectedDocs();
    } catch (error) {
      console.error('Error refetching files:', error);
    }
  };

  const RemoveFilesBtn = () => (
    <RemoveFilesButton
      key="deleteDocs"
      entityId={entityId}
      menu
      ids={selectedDocs.map(item => item.id)}
      onComplete={refetchFiles}
      disabled={selectedDocs.length === 0}
    >
      {selectedDocs.length === 0
        ? intl.formatMessage(messages.menuItemUnselectedDocumentsToRemove)
        : intl.formatMessage(messages.menuItemRemoveSelectedDocuments, {
            count: selectedDocs.length
          })}
    </RemoveFilesButton>
  );

  return <PersonDocs />;
};

export default PersonDocsTab;
